export interface MimeType {
    type: string;
}

export function getMimeType(filename: string): MimeType {
    let mimeType: MimeType = undefined;
    switch (filename.slice(filename.lastIndexOf('.')).toUpperCase()) {
        case '.CSD':
        case '.TXT':
        case '.XYZ':
        case '.PTS':
        case '.CSV':
            mimeType = {type: 'text/plain'};
            break;
        case '.PDF':
            mimeType = {type: 'application/pdf'};
            break;
        case '.DOC':
            mimeType = {type: 'application/msword'};
            break;
        case '.DOCX':
            mimeType = {type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'};
            break;
        case '.DWG':
            mimeType = {type: 'image/vnd.dwg'};
            break;
        case '.MSG':
            mimeType = {type: 'application/vnd.ms-outlook'};
            break;
        default:
            mimeType = {type: 'text/plain'};
    }
    return mimeType;
}
